import { on } from '@ngrx/store';

import { CancelPayLinkDialogActions } from './cancel-pay-link-dialog.actions';
import { CancelPayLinkDialogState } from './cancel-pay-link-dialog.state';

export const cancelPayLinkDialogReducers = [
    on(
        CancelPayLinkDialogActions.cancelPayLinkFromRowClicked,
        (state: CancelPayLinkDialogState, { transactionId, amountMinor, payUrl, hold }) => ({
            ...state,
            target: { transactionId, amountMinor, payUrl, hold: hold === true, cancelling: false },
        }),
    ),
    on(
        CancelPayLinkDialogActions.cancelPayLinkConfirmed,
        (state: CancelPayLinkDialogState): CancelPayLinkDialogState => ({
            ...state,
            target: state.target ? { ...state.target, cancelling: true } : undefined,
        }),
    ),
    on(
        CancelPayLinkDialogActions.cancelPayLinkDismissed,
        CancelPayLinkDialogActions.cancelPayLinkSuccess,
        (state: CancelPayLinkDialogState): CancelPayLinkDialogState => ({
            ...state,
            target: undefined,
        }),
    ),
    on(
        CancelPayLinkDialogActions.cancelPayLinkError,
        (state: CancelPayLinkDialogState): CancelPayLinkDialogState => ({
            ...state,
            target: state.target ? { ...state.target, cancelling: false } : undefined,
        }),
    ),
];
